/* eslint-disable import/prefer-default-export */
export const BYTES_IN_KIB = 1024;
export const HIDDEN_CLASS = 'hidden';



// WEBPACK FOOTER //
// ./lib/utils/constants.js